import AbstractWeatherModel from '@/lib/grow/abstract-weather-model'
import i18n from '@/lib/i18n'
import moment from 'moment'
import UserInfo from '@/lib/user-info'

export default class SoilMoisture extends AbstractWeatherModel {
  static fromApiResponse(data, observation) {
    let sm = new SoilMoisture()
    sm.setValuesFromApi(data, observation)
    sm.year = data.year
    sm.month = data.month
    sm.day = data.day
    sm.hour = data.hour
    sm.zoneId = data.zoneId
    sm.drainage = data.drainage
    sm.api = data.api
    sm.roundedApi = data.roundedApi
    sm.pf = data.pf
    sm.roundedPf = data.roundedPf
    sm.soilMoisture = data.soilMoisture
    return sm
  }

  static fromApiResponseOpenMeteo(soilMoistureValue) {
    let sm = new SoilMoisture()
    sm.soilMoisture = soilMoistureValue
    return sm
  }

  get keyForHash() {
    return this.geohash + '-' + this.year + this.month + this.day + this.hour + this.drainage
  }

  get icon() {
    switch (this.soilMoisture) {
      case 'VeryWet':
      case 'Wet':
      case 'Dry':
      case 'VeryDry':
        return '/icons/SoilMoisture_' + this.soilMoisture + '.png'
      default:
        return '?'
    }
  }

  get fontColorStyle() {
    let color = null
    switch (this.soilMoisture) {
      case 'VeryWet':
        color = '#6449b6'
        break
      case 'Wet':
        color = '#2791e5'
        break
      case 'Dry':
        color = '#f39100'
        break
      case 'VeryDry':
        color = '#ea5514'
        break
      default:
        color = '#000'
    }
    return { color }
  }

  get description() {
    const label = 'observation.soilCondition' + this.soilMoisture
    return i18n.tt(label)
  }

  get date() {
    const lang = UserInfo.getLanguage()
    const m = moment({ year: this.year, month: this.month - 1, day: this.day, hour: this.hour }).locale(lang)
    return m.format('ll')
  }
}
